import * as React from "react";
import { TTranslate } from "../../../../service/locale/TranslationService";
import { FormComponentProps } from "antd/lib/form";
import ApplicantRequestForm from "./ApplicantRequestForm";

export interface State {}

export interface CreateApplicantRequestFormProps extends FormComponentProps {
  translate: TTranslate;
  registerFormSubmitEventHandler: any;
  codebooks: any[];
}

class CreateApplicantRequestForm extends React.Component<
  CreateApplicantRequestFormProps,
  State
> {
  componentDidMount() {
    const { registerFormSubmitEventHandler } = this.props;
    registerFormSubmitEventHandler(e => {
      e.preventDefault();
      let newApplicantRequest;
      this.props.form.validateFields((err, values) => {
        if (!err) {
          newApplicantRequest = values;
          newApplicantRequest.reportingPeriodApplicantId= parseInt(values.reportingPeriodApplicantId, 10);
        }
      });
      return newApplicantRequest;
    });
  }

  render() {
    const { translate, codebooks } = this.props;

    const { getFieldDecorator } = this.props.form;
    return (
      <ApplicantRequestForm
        getFieldDecorator={getFieldDecorator}
        translate={translate}
        codebooks={codebooks}
      />
      
     
    );
  }
}

export default CreateApplicantRequestForm;
